import React from 'react';
import { Check } from 'lucide-react';
import { Section } from './Shared';
export const First30Days = () => {
  const stats = [{
    title: '📘 Tomo Principal',
    desc: '50 páginas de metodología clínica'
  }, {
    title: '📋 Bonus 1',
    desc: '30 páginas de planillas de sesión'
  }, {
    title: '📦 Bonus 2',
    desc: '30 páginas de control de gabinete'
  }, {
    title: '🦶 Planillas de registro',
    desc: '18 modelos diferentes'
  }, {
    title: '📊 Planillas de stock',
    desc: '20 modelos diferentes'
  }, {
    title: '✅ Checklists',
    desc: '3 checklists plastificables'
  }];
  return <Section className="max-w-4xl" data-id="element-72">
      <div className="text-center mb-12" data-id="element-73">
        <h2 className="md:text-4xl font-serif font-bold mb-4 text-[24px] text-brand-rose" data-id="element-74">
          📊 LO QUE RECIBÍS EN NÚMEROS
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-75">
        {stats.map((stat, i) => <div key={i} className="glass-panel p-6 rounded-2xl border-brand-pink/30 relative overflow-hidden" data-id="element-76">
            <div className="absolute top-0 left-0 w-1 h-full bg-brand-rose" data-id="element-77"></div>
            <h3 className="font-serif font-bold mb-2 text-brand-text text-[16px]" data-id="element-78">
              {stat.title}
            </h3>
            <p className="text-brand-text/80 text-[14px]" data-id="element-79">{stat.desc}</p>
          </div>)}
      </div>

      <div className="glass-panel p-8 md:p-10 rounded-3xl mb-12 text-center bg-brand-rose/5 border-brand-rose/20" data-id="element-80">
        <h3 className="font-serif font-bold text-brand-rose text-[24px]" data-id="element-81">
          📄 TOTAL: 110 páginas listas para usar
        </h3>
      </div>
    </Section>;
};